export interface TotalLineProps {
  /** Rótulo a la izquierda. */
  label?: string;
  /** Cifra grande ya formateada. */
  value: string;
}

/** "Total" a la izquierda y la cifra grande a la derecha, alineadas por la línea base. */
export function TotalLine({ label = "Total", value }: TotalLineProps) {
  return (
    <div className="mb-3 flex items-baseline justify-between">
      <span className="text-[11px] font-medium uppercase leading-[14px] tracking-[0.14em] text-[var(--ds-ink-muted)]">{label}</span>
      <b className="text-[30px] font-medium leading-[34px] font-[var(--ds-font-sans)]">{value}</b>
    </div>
  );
}
